import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useState} from "../../__snowpack__/pkg/react.js";
import {Tooltip} from "../../__snowpack__/pkg/antd.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
import {Modal} from "../../__snowpack__/pkg/antd.js";
import {IconEdit, IconPlus} from "../../__snowpack__/pkg/@genieui-react/icon.js";
import {Uploader} from "./Uploader2.js";
export const UploaderWithModal = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [list, setList] = useState([]);
  const file = useMemo(() => {
    return list.find((_) => _);
  }, [list]);
  useImperativeHandle(ref, () => ({
    setVisible
  }));
  useEffect(() => {
    setList([...props.value || []]);
  }, [props.value]);
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "uploader-with-modal"
  }, /* @__PURE__ */ React.createElement("div", {
    onClick: () => {
      setVisible(true);
    },
    className: "uploader-with-modal-content"
  }, !file && /* @__PURE__ */ React.createElement(IconPlus, null), file && /* @__PURE__ */ React.createElement("div", {
    className: "content-uploaded"
  }, /* @__PURE__ */ React.createElement("img", {
    src: file?.response || file?.url || file?.thumbUrl
  }), /* @__PURE__ */ React.createElement("div", {
    className: "content-uploaded-mask",
    style: {
      display: visible ? "flex" : void 0
    }
  }, /* @__PURE__ */ React.createElement(IconEdit, {
    primaryColor: "#FFF"
  })))), /* @__PURE__ */ React.createElement(Tooltip, {
    title: `${props.title} (${list.length / props.limitNum})`
  }, /* @__PURE__ */ React.createElement("div", {
    id: props.id,
    className: "uploader-with-modal-title"
  }, props.title, " (", list.length, "/", props.limitNum, ")")), /* @__PURE__ */ React.createElement(Modal, {
    visible,
    onOk: () => {
      setVisible(false);
    },
    onCancel: () => {
      setVisible(false);
    },
    ...props.modalProps
  }, props.modalTips, /* @__PURE__ */ React.createElement(Uploader, {
    value: list,
    limitNum: props.limitNum,
    onChange: (fileList) => {
      props.onChange && props.onChange(fileList);
      setList(fileList);
    },
    ...props.uploaderProps
  })));
});
const Wrapper = styled.div`
  &.uploader-with-modal {
    cursor: pointer;
    width: 100px;
  }
  .uploader-with-modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    background: #fafdff;
    border-radius: 4px;
    border: 1px dashed #7f8fa4;
    .content-uploaded {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 8px;
      width: 100%;
      height: 100%;
      overflow: hidden;
      > img {
        width: 100%;
        height: auto;
      }
      &:hover .content-uploaded-mask {
        display: flex;
      }
      .content-uploaded-mask {
        display: none;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .uploader-with-modal-title {
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
